import Vue from 'vue'
import Vuex from 'vuex'
import globals from './modules/globals'
import patients from './modules/patients'
import patientsgallery from './modules/patientsgallery'
import ordinations from './modules/ordinations'
import tehnicallabs from './modules/tehnicallabs'
import workorders from './modules/workorders'
import users from './modules/users'
import dentalsolutioncompanies from './modules/dentalsolutioncompanies'

Vue.use(Vuex)

// the root, initial state object
const store = new Vuex.Store({
  modules: {
      globals,
      patients,
      patientsgallery,
      ordinations,
      tehnicallabs,
      workorders,
      users,
      dentalsolutioncompanies,
  }
});

// create the Vuex instance by combining the state and mutations objects
// then export the Vuex store for use by our components
export default store



// WEBPACK FOOTER //
// ./src/store/index.js